<template>
    <div class="paper-polish-submit">
      <BreadCrumb>
        <template>
          <el-breadcrumb-item>论文降重</el-breadcrumb-item>
        </template>
      </BreadCrumb>
      <InnerBox>
        <template>
            <div id="StepBar">
                <el-steps :active="0" align-center style="padding:0 0 30px">
                    <el-step title="填写表单"></el-step>
                    <el-step title="后台确认"></el-step>
                    <el-step title="业务进行"></el-step>
                    <el-step title="支付订单"></el-step>
                    <el-step title="稿件完成"></el-step>
                </el-steps>
            </div>

  <!--        <el-steps :active="step" align-center finish-status="success" style="padding: 0 0 30px;">-->
  <!--          <el-step title="标题"></el-step>-->
  <!--          <el-step title="作者"></el-step>-->
  <!--          <el-step title="业务类型"></el-step>-->
  <!--          <el-step title="字数"></el-step>-->
  <!--          <el-step title="周期"></el-step>-->
  <!--          <el-step title="上传文件"></el-step>-->
  <!--          <el-step title="备注"></el-step>-->
  <!--          <el-step title="发票信息"></el-step>-->
  <!--          <el-step title="提交"></el-step>-->
  <!--        </el-steps>-->
          <el-form ref="form" :model="form" label-width="80px" size="mini" class="polish-create-form">
            <el-form-item label="文章标题">
              <el-input v-model="form.title" style="width: 700px; margin-right: 15px;" @focus="step=0">
              </el-input>
              <el-button type="primary" @click="onSubmit" style="width: 73px">提交</el-button>
            </el-form-item>
            <el-form-item label="作者名字">
              <el-input v-model="form.author" style="width: 700px; " @focus="step=1">
              </el-input>
            </el-form-item>
            <el-form-item label="业务类型">
              <el-radio-group v-model="form.type" size="medium" @change="step=2">
                <el-radio label="3">降重/改写</el-radio>
  <!--              <el-radio label="4">深度降重</el-radio>-->
              </el-radio-group>
            </el-form-item>
            <el-form-item label="文档字数">
              <el-radio-group v-model="form.wordLevel" size="medium" @change="step=3">
                <el-radio label="1">1-1800</el-radio>
                <el-radio label="2">1801-4000</el-radio>
                <el-radio label="3">4001-7000</el-radio>
                <el-radio label="4">7001-10000</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="重复率" v-if="form.type==='3'">
              <el-radio-group v-model="form.period" size="medium" @change="step=3">
                <el-radio label="1">20-40%</el-radio>
                <el-radio label="2">41-60%</el-radio>
                <el-radio label="3">61-80%</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="周期" v-if="form.type==='3'">
                <template slot="label">
                    周&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp期
                </template>
                {{getPeriodName(form.type, form.wordLevel, form.period)}}
            </el-form-item>
            <!--              accept=".doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"-->
            <el-form-item label="论文">
                <template slot="label">
                    论&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp文
                </template>
                <!-- 未登陆时显示，提示登陆/注册 -->
                <el-tooltip v-if="this.global.account == null" class="item" effect="dark" content="请先登陆/注册" placement="top">
                    <el-button size="small" type="primary"><i class="el-icon-upload"></i>点击上传</el-button>
                    <span class="colorSpan">仅支持docx、doc格式的文档</span>
                </el-tooltip>
                <!-- 登陆时显示 -->
                <el-upload v-if="this.global.account != null"
                    class="upload-demo"
                    :auto-upload="true"
                    :limit="2"
                    ref="elUpload"
                    :headers="headers"
                    accept="application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                    @on-change="step=5"
                    :action="baseUrl+'api/paper/upload'"
                    :on-success="onUploadSuccess"
                    :before-remove="onRemove">
                    <el-button size="small" type="primary"><i class="el-icon-upload"></i>点击上传</el-button>
                    <span class="colorSpan">仅支持docx、doc格式的文档</span>
                </el-upload>

            </el-form-item>
              <el-form-item label="手机号码">
                  <el-input v-model="form.phone"></el-input>
              </el-form-item>
            <el-form-item label="备注">
                <template slot="label">
                    备&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp注
                </template>
              <div style="border: 1px solid #ccc;">
                <Editor
                    @onChange="step=6"
                  style="height: 100px; overflow-y: hidden;"
                  v-model="form.demand"
                  :defaultConfig="editorConfig"
                  :mode="mode"
                />
              </div>
            </el-form-item>
            <el-form-item label="需要发票">
                <el-switch
                    @change="step=7"
                    v-model="form.hasInvoice"
                    active-color="#14aab9"
                    inactive-color="#c1c1c1">
                </el-switch>
                <div v-if="form.hasInvoice" style="    display: inline;color: #606266; margin-left: 15px;line-height: 28px;">类型:电子版普票 发票内容:润色服务费</div>
            </el-form-item>
              <div v-if="form.hasInvoice">
                <el-form-item label="发票抬头">
                    <el-input v-model="form.invoice.entityName"></el-input>
                </el-form-item>
                <el-form-item label="税号">
                    <template slot="label">
                        税&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp号
                    </template>
                    <el-input v-model="form.invoice.taxNumber"></el-input>
                </el-form-item>
                <el-form-item label="开户行">
                    <template slot="label">
                        开&nbsp&nbsp户&nbsp&nbsp行
                    </template>
                    <el-input v-model="form.invoice.bank"></el-input>
                </el-form-item>
                <el-form-item label="手机号">
                    <template slot="label">
                        手&nbsp&nbsp机&nbsp&nbsp号
                    </template>
                    <el-input v-model="form.invoice.phone"></el-input>
                </el-form-item>
                <el-form-item label="接收邮箱">
                    <el-input v-model="form.invoice.email" @change="step=8"></el-input>
                </el-form-item>
              </div>
  <!--          <el-form-item>-->
  <!--            <el-button type="primary" @click="onSubmit">提交</el-button>-->
  <!--            <el-button>取消</el-button>-->
  <!--          </el-form-item>-->
          </el-form>
        </template>
      </InnerBox>
      <InnerBox style="margin-top: 10px">
          <div class="tool mt15" >
              <h3>使用说明</h3>
              <div>
                  <div style="text-align: initial;">
                      （1）对于降重服务，用户提交的稿件需要经我们确认，稿件中科学术语过多等因素会导致重复率很难降低到20% 以内。需要跟用户详细沟通。<br/>
                      （2）如需加急、格式调整等服务，请添加客服微信。<br/>
                      （3）该服务仅支持英文稿件,如其他语言请联系客服。<br/>
                      <!-- <div style="text-align: center">
                          <img src="../assets/wechat_qrcode.jpg" width="160px" height="160px" style="padding-top: 20px;"><br/>
                          扫码（添加微信号cytotry）联系客服
                      </div> -->
                  </div>
              </div>
          </div>
      </InnerBox>
    </div>


  </template>

  <script>
  import InnerBox from "./InnerBox";
  import BreadCrumb from "./BreadCrumb";
  import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
  import {BaseUrl} from '@/utils/request.js'
  import { getToken } from '@/utils/auth'
  import request from '@/utils/request'
  import {eventBus} from "../main";

  export default {
    name: "PaperPolish",
    components: {BreadCrumb, InnerBox, Editor, Toolbar},
    data() {
      return {
        headers: { 'Authorization': getToken() },
        form: {
          title: '',
          author: '',
          type: '',
          demand: '',
          wordLevel: '',
          period: '',
          phone: '',
          fileId: null,
          hasInvoice: false,
          invoice: {
              entityName: '',
              taxNumber: '',
              bank: '',
              phone: '',
              email: '',
          }
        },
        editor: null,
        toolbarConfig: { },
        editorConfig: { placeholder: '请输入内容...' },
        mode: 'default', // or 'simple',
        baseUrl: BaseUrl,
        step: 0,
      }
    },
    methods: {
        getPeriodName(type, wordLevel, period) {
            if(type == 1) {
                if(wordLevel < 3) {
                    //period 1~4
                    if(period == 1) {
                        return "5天"
                    } else if(period == 2) {
                        return "4天"
                    } else if(period == 3) {
                        return "3天"
                    } else {
                        return "2天"
                    }
                } else if(wordLevel == 3) {
                    if(period == 1) {
                        return "7天"
                    } else if(period == 2) {
                        return "4天"
                    } else if(period == 3) {
                        return "3天"
                    } else {
                        return "2天"
                    }
                } else {
                    if(period == 1) {
                        return "7天"
                    } else if(period == 2) {
                        return "6天"
                    } else {
                        return "5天"
                    }
                }
            } else if(type == 2) {
                return (2+2*wordLevel) + "天"
            } else {
                /*
                  0-1800  20-40，41-60，61-70 3;5; 7
                  1800-4000 20-40，41-60，61-70 3;5;7
                  4000-7000 20-40，41-60，61-70 5; 7: 10
                  7000-10000 20-40，41-60，61-70 5; 10; 14;
                   */
                if(wordLevel == 1) {
                    if(period == 1) {
                        return "3天"
                    } else if(period == 2) {
                        return "5天"
                    } else {
                        return "7天"
                    }
                } else if(wordLevel == 2) {
                    if(period == 1) {
                        return "3天"
                    } else if(period == 2) {
                        return "5天"
                    } else {
                        return "7天"
                    }
                } else if(wordLevel == 3) {
                    if(period == 1) {
                        return "5天"
                    } else if(period == 2) {
                        return "7天"
                    } else {
                        return "10天"
                    }
                } else {
                    if(period == 1) {
                        return "5天"
                    } else if(period == 2) {
                        return "10天"
                    } else {
                        return "14天"
                    }
                }
            }
        },
        getRepeatRateName(repeatRate) {
            if(repeatRate == 1) {
                return "20-40%";
            } else if(repeatRate == 2) {
                return "41-60%";
            } else {
                return "61-70%";
            }
        },

      onSubmit() {
        if(this.global.account == null) {
          this.$message({
            message: '请先登录',
            type: 'warning'
          });
            eventBus.$emit('show-login', '');
        }else{
            if(this.form.title.length < 1) {
          this.$message({
            message: '请输入标题',
            type: 'warning'
          });
          return
        }

        if(this.form.fileId == null) {
          this.$message({
            message: '请先上传文件',
            type: 'warning'
          });
          return
        }

          let typeName = [
          "",
              "润色",
              "翻译",
              "降重",
              "深度降重",
          ]

          let wordLevelName = [
              "",
              "<3000字",
              "3001-4000字",
              "4001-5000字",
              "5001-6000字",
              "6001-7000字",
              ">7000字",
          ]

          let periodName = [
              "",
              "5-8天",
              "6-9天",
              "7-11天",
          ]

          let getWordLevelName = (type, wordLevel) => {
              if(type == 3) {
                  // 降重
                  if(wordLevel == 1) {
                      return "1-1000"
                  } else if(wordLevel == 2) {
                      return "1001-3000"
                  } else {
                      return "3001-5000"
                  }
              } else {
                  if(wordLevel == 1) {
                      return "1-1800"
                  } else if(wordLevel == 2) {
                      return "1801-4000"
                  } else if(wordLevel == 3) {
                      return "4001-7000"
                  } else {
                      return "7001-10000"
                  }
              }
          }

          let hasInvoice = this.form.hasInvoice
          let invoice = this.form.invoice

          //check type wordlevel period
          if(this.form.type == '') {
              this.$message({
                  message: '请选择业务类型',
                  type: 'warning'
              });
              return
          }

          if(this.form.wordLevel == '') {
              this.$message({
                  message: '请选择字数',
                  type: 'warning'
              });
              return
          }

          if(this.form.period == '') {
              this.$message({
                  message: '请选择周期',
                  type: 'warning'
              });
              return
          }

            if(this.form.author == '') {
                this.$message({
                    message: '请输入作者名字',
                    type: 'warning'
                });
                return
            }

          //check phone reg
          let phoneReg = /^1[3456789]\d{9}$/
          if(!phoneReg.test(this.form.phone)) {
              this.$message({
                  message: '请输入正确的手机号',
                  type: 'warning'
              });
              return
          }

          request({
              url: "api/paper/calcPolish",
              method: "post",
              data: this.form
          }).then((r) => {
              if(r.msg !== undefined) {
                  this.$message({
                      message: r.msg,
                      type: 'warning'
                  });
                  return
              }

              console.log(r);

              let hintContent = '标题:'+r.title +
                  '<br/>业务类型：'+typeName[r.type]+
                  '<br/>字数：'+getWordLevelName(r.type, r.wordLevel)

              if(r.type == 3) {
                  hintContent += '<br/>重复率：'+ this.getRepeatRateName(r.period)
              }

              hintContent +=
                  '<br/>周期：'+this.getPeriodName(r.type, r.wordLevel, r.period) +
                  '<br/>手机号：'+r.phone +
                  '<br/>价格：￥'+r.price.toFixed(2);

              if(hasInvoice) {
                  hintContent +=
                      '<br/>抬头:'+ invoice.entityName+
                      '<br/>税号:'+ invoice.taxNumber+
                      '<br/>开户行:'+ invoice.bank+
                      '<br/>手机号:'+ invoice.phone+
                      '<br/>邮箱:'+ invoice.email
              }

              hintContent += '<br/>请仔细核对订单，一旦确定便不能修改';

              this.$confirm(hintContent, '确认订单', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  dangerouslyUseHTMLString: true,
                  type: 'info',
                  customClass: 'order-confirmation'
              }).then(() => {
                  request({
                      url: "api/paper/createPolish",
                      method: "post",
                      data: this.form
                  }).then((r) => {
                      console.log(r);
                      if(r.code === undefined) {
                          this.form = {
                              title: '',
                              type: '1',
                              demand: '',
                              wordLevel: '1',
                              period: '1',
                              fileId: null
                          }
                          this.$refs.elUpload.clearFiles()

                          //支付
                          this.$message.success("提交成功,请等待审核")
                          this.$router.push('/paper/my_polish')
                      }
                  }).catch(error => {
                      console.log(error);
                  });
              })
          }).catch(error => {
              console.log(error);
          });
        }
      },
    //   onCreated(editor) {
    //     if(this.global.account == null) {
    //       this.$message({
    //         message: '请先登录',
    //         type: 'warning'
    //       });

    //         this.$router.replace('/')
    //         eventBus.$emit('show-login', '');
    //     }

    //     console.log(editor.getConfig())
    //     this.editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
    //   },
      onRemove() {
        this.form.fileId = null
      },
      onUploadSuccess(response, file, fileList) {
        if(Number(response) != response) {
          this.$refs.elUpload.clearFiles()
          return;
        }
        console.log(response, file, fileList)
        this.form.fileId = response
          this.step=5
      }
    }
  }
  </script>
  <style scoped>
    #StepBar{
        width: 500px;
    }
  </style>
  <style>
  .polish-create-form .el-input {
      /*width: 700px;*/
  }

  .paper-polish-submit .el-step__title {
      font-size: 14px;
      /*font-weight: initial;*/
  }
  .colorSpan{
    color: #606266;
}
  </style>
  <style src="@wangeditor/editor/dist/css/style.css"></style>




// WEBPACK FOOTER //
// src/components/PaperDropWeight.vue